<section>
  <h1>Events</h1>
  <a *removeIfUnauthorized="canCreateEvent" (click)="newEvent()" class="btn btn-active mb-3">Add event</a>
  <p-messages key="eventsMsgs" [closable]="true"></p-messages>
  <div class="card mb-3">
    <div #tgt id="filterBody" class="card-body p-0">
      <ness-date-range-filter #df [dateFilterVerbiage]="'Filter by event date range:'" [dateFilterStorageKey]="eventsStorageKey"></ness-date-range-filter>
      <ness-geographic-filter *removeIfNoPermission="canViewEventFilters" #gf [geoFilterVerbiage]="'Filter by Geographic Region:'" [geoFilterStorageKey]="geoFilterStorageKey"></ness-geographic-filter>
      <div class="ms-sm-auto px-sm-3 py-2 px-md-4 font-size-sm">
        <button type="button" class="btn btn-success mb-2 me-sm-2" [disabled]="loading" [attr.aria-disabled]="loading" (click)="applyFilters()" title="Apply filters">Apply<span class="visually-hidden"> filters</span></button>
        <button type="button" class="btn btn-secondary mb-2" [disabled]="loading" [attr.aria-disabled]="loading" (click)="resetDefaultFilters()" title="Reset filters to defaults">Reset<span class="visually-hidden"> filters to defaults</span></button>
      </div>
    </div>
  </div>
  <p-table #dt [columns]="cols" [value]="events" selectionMode="single" [(selection)]="selectedEvent" [paginator]="true" [alwaysShowPaginator]="false" [rows]="rows" (sortFunction)="eventListCustomSort($event)" [customSort]="true" [autoLayout]="true" responsiveLayout="scroll" [stateKey]="gridStateKey" stateStorage="session" (onStateRestore)="restoreEventsGridState($event)">
    <ng-template pTemplate="caption">
      <ness-paged-loading-status *ngIf="loading" [startRow]="loadingStartRow$ | async" [endRow]="loadingEndRow$ | async" [messageTemplate]="messageTemplate"></ness-paged-loading-status>
      <div class="d-flex flex-wrap p-2 mx-2 filter-status font-size-sm">
        <ng-container *removeIfNoPermission="canViewEventFilters">
          <div class="p-2 me-2">Showing:</div>
          <ness-date-range-filter-status></ness-date-range-filter-status>
          <ness-geographic-filter-status></ness-geographic-filter-status>
        </ng-container>
        <div class="ms-md-2 ms-lg-auto me-2">
          <div class="input-group">
            <span class="input-group-text"><i class="fa fa-search" aria-hidden="true"></i></span>
            <input type="text" pInputText class="form-control" placeholder="Events filter" (input)="dt.filterGlobal($event['target']['value'], 'contains')" aria-label="Globally filter the events grid" name="eventsGlobalFilterInput">
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field" scope="col">
          {{col.header}}
          <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
      </tr>
      <tr>
        <th scope="col">
          <p-columnFilter field="LECaseNumber" matchMode="contains" [showMenu]="false" [showClearButton]="false" display="row">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input aria-label="Filter by LE case number" pInputText type="text" name="lcnFilterInput" (input)="filter($event['target']['value'])" placeholder="Filter by LE case number" class="form-control form-control-sm" />
            </ng-template>
          </p-columnFilter>
        </th>
        <th scope="col"><span class="visually-hidden">(No filter available for event date column)</span></th>
        <th scope="col">
          <p-columnFilter field="CrimeTypeName" matchMode="contains" [showMenu]="false" [showClearButton]="false" display="row">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <select id="ctfilter" pDropdown class="form-select form-select-sm" name="crimeTypeFilterSelect" (change)="filter($event['target']['value'])" aria-label="Filter by crime type">
                <option value="" selected>All crime types</option>
                <option *ngFor="let crime of crimeTypes$ | async" value="{{crime.value}}">{{crime.label}}</option>
              </select>
            </ng-template>
          </p-columnFilter>
        </th>
        <th scope="col">
          <p-columnFilter field="AgencyName" matchMode="contains" [showMenu]="false" [showClearButton]="false" display="row">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <input pInputText type="text" name="agencyFilterInput" (input)="filter($event['target']['value'])" placeholder="Filter by agency name" class="form-control form-control-sm" />
            </ng-template>
          </p-columnFilter>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr [pSelectableRow]="rowData">
        <ng-container *ngFor="let col of columns">
          <td scope="row" *ngIf="col.field == 'LECaseNumber';else tddefault">
            <button type="button" aria-label="{{'Open the LE Case Number '+rowData.LECaseNumber+' details'}}" (click)="viewDetails(rowData)" class="btn btn-link px-0">{{rowData[col.field]}}</button>
          </td>
          <ng-template #tddefault>
            <td [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'EventDateOffset'"><span class="text-nowrap">{{rowData[col.field] | date:'MM/dd/yyyy  HH:mm':rowData.TimeOffset}} ({{rowData.TimeZoneAbbreviation}})</span></ng-container>
              <ng-container *ngSwitchCase="'CrimeTypeName'">
                {{rowData[col.field]}}<ng-container *ngIf="rowData.CrimeTypeName==='Other'">: {{rowData.OtherCrimeType}}</ng-container>
              </ng-container>
              <ng-container *ngSwitchDefault>
                {{rowData[col.field]}}
              </ng-container>
            </td>
          </ng-template>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length">
          No events found.
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>
<aside>
  <p-sidebar #sb (onShow)="onShowSidebar(sb)" (onHide)="eventDetail.showEventNarrative = false" [(visible)]="openViewDetailForm" position="right" [blockScroll]="true" styleClass="p-sidebar-lg" [showCloseIcon]="false">
    <ness-event-detail #eventDetail (showEventDetail)="openViewDetailForm = false" [event]="event" [crimeTypeName]="crimeTypeName" [hasEditPermission]="hasEditPermission"></ness-event-detail>
  </p-sidebar>
</aside>

